"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReviewerRoles = exports.REVIEWER_ROLES_ASCENDING = exports.ReviewerRoleSchema = exports.ReviewerRole = void 0;
const z = require("zod");
var ReviewerRole;
(function (ReviewerRole) {
    ReviewerRole["Senior"] = "senior_reviewer";
    ReviewerRole["Expert"] = "expert_reviewer";
})(ReviewerRole || (exports.ReviewerRole = ReviewerRole = {}));
exports.ReviewerRoleSchema = z.nativeEnum(ReviewerRole);
exports.REVIEWER_ROLES_ASCENDING = [ReviewerRole.Senior, ReviewerRole.Expert];
class ReviewerRoles {
    static rank(role) {
        return exports.REVIEWER_ROLES_ASCENDING.indexOf(role);
    }
    static outranks(role, other) {
        return ReviewerRoles.rank(role) > ReviewerRoles.rank(other);
    }
    static satisfiedBy(role) {
        if (role === null) {
            return [];
        }
        return exports.REVIEWER_ROLES_ASCENDING.filter((candidate) => !ReviewerRoles.outranks(candidate, role));
    }
}
exports.ReviewerRoles = ReviewerRoles;
//# sourceMappingURL=reviewer-role.js.map